/* src/app/rt-components/logo/logo.component.scss */
:host {
  display: block;
}
:host .logo {
  align-items: flex-end;
  display: flex;
  height: 100%;
  padding: 5px 10px;
  background-color: #FFFFFF;
}
:host .logo .logo-img {
  height: auto;
  width: auto;
  background-color: #ffffff;
}
/*# sourceMappingURL=logo.component.css.map */
